<div *ngIf="!loading">
  <div class="form-group row">
    <label class="col-md-2 col-xl-1 col-form-label">Show </label>
    <select class="form-control col-md-3 col-xl-2" [(ngModel)]="btnFilterSelected" (change)="buttonFilter(btnFilterSelected)">
      <option value="all">All</option>
      <option value="minus">Visible {{vReports}}</option>
      <option value="plus">Available {{aReports}}</option>
    </select>
    <span class="px-2"></span>
    <div class="mb-2">
      <button class="btn btn-outline-success" [disabled]="aReports == 0" *ngIf="(this.mode != 0 && this.mode.toString() != 'editMode')" (click)="addAll()">Add All</button>
    </div>
    <span class="px-2"></span>
    <div class="mb-2">
      <button class="btn btn-outline-danger" [disabled]="vReports == 0" *ngIf="(this.mode != 0 && this.mode.toString() != 'editMode')" (click)="removeAll()">Remove All</button>
    </div>
  </div>
  

  <input id="reportsearch" [(ngModel)]="search" class="form-control filter-input" style="margin-bottom:20px;" placeholder="Search by Report Name, Report Description or Report Group" />

  <div>
    <form>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="avaTable" class="form-control-label">{{tableName}} Reports</label>
          <div style="max-height:600px;overflow-y:scroll;" *ngIf="reportsAva.length > 0">
            <table class=" table table-hover" id="avaTable" name="avaTable">
              <tr>
                <th>Report Name <i class="fas fa-sort" (click)="orderList('reportName')"></i></th>
                <th>Report Description</th>
                <th>Tags</th>
                <th></th>
              </tr>
              <tr *ngFor="let ra of reportsAva | reportsACLFilter: search:dummbyValue;let i = index">
                <td>{{ra.reportName}} </td>
                <td><p data-placement="top" data-toggle="tooltip" title="{{ra.reportDescPopup}}">{{ra.reportDescription | truncate : 50 : true}} </p></td>
                <td><p *ngFor="let tag of ra.reportGroup">{{tag}}</p></td>
                <td style="width:60px;">
                  <button type="button" class="{{ra.lockClass}}" (click)="changeReportAssoc(ra, i)"><i class="{{ra.lockIcon}}"></i></button>
                </td>
              </tr>
            </table>
          </div>
          <div *ngIf="reportsAva.length == 0" class="alert alert-info" role="alert">
            No Reports Available.
          </div>
        </div>
      </div>


    </form>
  </div>
</div>

<div style="width:100%">
  <div *ngIf="loading" class="spinner-border" style="width: 3rem; height: 3rem; display:flex;margin-left:auto;margin-right:auto;" role="status"></div>
</div>
